import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';

type TPayload = {
  firstName?: string;
  lastName?: string;
  email?: string;
  addressLine1?: string;
  city?: string;
  country?: string;
  zipCode?: string;
};

export const setBillingDetails = (state: Draft<IPaymentState>, { payload }: PayloadAction<TPayload>) => {
  state.billingDetails = {
    ...state.billingDetails,
    ...payload,
  };
  state.updatedAt = Date.now();
};
